import { Monograph } from './monograph.model';

export class MonographSalesCatalogue {
    code: string;
    currencyCode: string;
    monographs: Monograph[];
}
